module.exports = __webpack_public_path__ + "static/media/solution-chain-banner.92c16ea5.jpg";